import {useSelect} from '@wordpress/data';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {PaymentMethodMessagingElement, Elements} from "@stripe/react-stripe-js";
import {initStripe} from "@wc-stripe/blocks-utils";
import {SilentErrorBoundary} from "../../shared";
import {PaymentMethodLabel} from "../payment-method-label";

export const BNPLMessageLabel = ({data, paymentMethodTypes, title, icons, paymentMethod, components}) => {
    const {cartTotals, billingAddress} = useSelect(select => {
        const store = select(CART_STORE_KEY);
        return {
            cartTotals: store.getCartTotals(),
            billingAddress: store.getCustomerData().billingAddress || {}
        }
    });

    if (!data || data?.locations?.checkout === 'below_total') {
        return (
            <PaymentMethodLabel
                paymentMethod={paymentMethod}
                title={title}
                icons={icons}
                components={components}/>
        );
    }

    const countryCode = billingAddress?.country || data.countryCode;
    const currency = cartTotals.currency_code || '';

    if (!data.currencies.includes(currency)) {
        return null;
    }

    if (!data.countries.includes(countryCode)) {
        return null;
    }

    const {PaymentMethodLabel: Label} = components;
    const options = {
        amount: parseInt(cartTotals.total_price || 0),
        currency: currency.toUpperCase(),
        paymentMethodTypes,
        countryCode
    };

    return (
        <div className={'wc-stripe-label-container'}>
            <Label text={title}/>
            <SilentErrorBoundary>
                <div className={'wc-stripe-bnpl-payment-title--container'}>
                    <Elements
                        stripe={initStripe}
                        options={{
                            ...data.elementOptions,
                            appearance: {
                                ...data.elementOptions.appearance,
                                rules: {
                                    ...data.elementOptions.appearance?.rules,
                                    '.PaymentMethodMessaging': {
                                        ...data.elementOptions.appearance?.rules?.['.PaymentMethodMessaging'],
                                        textAlign: 'right'
                                    }
                                }
                            }
                        }}>
                        <PaymentMethodMessagingElement
                            options={options}/>
                    </Elements>
                </div>
            </SilentErrorBoundary>
        </div>
    );
}